import Component from "./Dimmer";
export default Component;
